import type { AdminShopStatus } from '@agenda-facil/contracts';
import { StatusPill } from '@agenda-facil/ui';
import { adminStatusMeta } from './admin-format';

export function AdminStatusPill({ status }: { status: AdminShopStatus }) {
  const meta = adminStatusMeta[status];
  return <StatusPill tone={meta.tone}>{meta.label}</StatusPill>;
}
